import Axios from "@/models/axios";

class ShareCalculatorApi extends Axios {
  path() {
    return `papi/ShareCalculator/${process.env.VUE_APP_SHARE_CALCULATOR_UNIQUE_IDENTIFIER_KEY}`
  }
}

export default ShareCalculatorApi;